export const common = {
  nav: {
    overview: 'Aperçu',
    services: 'Services',
    industries: 'Secteurs',
    about: 'À Propos',
    contact: 'Contact',
    getStarted: 'Commencer'
  },
  hero: {
    badge: 'Fournisseur Mondial de Solutions IT',
    title: 'Infrastructure qui Alimente votre Avenir Numérique',
    subtitle: 'Votre couteau suisse numérique pour l\'excellence IT complète. Des projets d\'infrastructure complexes aux solutions audiovisuelles et de surveillance de pointe - nous livrons des résultats professionnels dans tous les domaines technologiques.',
    exploreSolutions: 'Découvrir les Solutions',
    learnMore: 'En Savoir Plus'
  },
  services: {
    sectionTitle: 'NOTRE EXPERTISE',
    title: 'Solutions IT Complètes Adaptées à votre Entreprise',
    subtitle: 'Nous fournissons des services IT personnalisés qui répondent à vos défis uniques et font progresser votre entreprise.',
    learnMore: 'En savoir plus',
    itInfrastructure: {
      title: 'Infrastructure IT',
      description: 'Solutions réseau évolutives conçues pour soutenir la croissance de votre entreprise. De la gestion des serveurs à l\'intégration cloud, nous construisons une infrastructure robuste qui garantit fiabilité et performance.'
    },
    digitalisation: {
      title: 'Numérisation',
      description: 'Transformez vos processus métier avec des solutions numériques de pointe. Nous aidons les organisations à moderniser leurs opérations, améliorer l\'efficacité et rester compétitives à l\'ère numérique.'
    },
    backup: {
      title: 'Solutions de Sauvegarde',
      description: 'Systèmes complets de protection des données et de reprise après sinistre. Protégez vos données critiques avec des sauvegardes automatisées, un stockage sécurisé et des capacités de récupération rapide.'
    },
    surveillance: {
      title: 'Systèmes de Surveillance',
      description: 'Solutions de surveillance de sécurité avancées adaptées à vos besoins. Protégez vos actifs avec une technologie de surveillance de pointe et des capacités de surveillance 24/7.'
    },
    cybersecurity: {
      title: 'Cybersécurité',
      description: 'Protégez votre entreprise contre les cybermenaces évolutives avec des solutions de sécurité complètes. Nous mettons en œuvre une détection avancée des menaces, des systèmes de prévention et des protocoles de sécurité pour protéger vos actifs numériques.'
    },
    managedServices: {
      title: 'Services Gérés',
      description: 'Concentrez-vous sur votre cœur de métier pendant que nous gérons vos opérations IT. Nos services gérés offrent une surveillance proactive, une maintenance et un support pour maintenir vos systèmes en bon état 24/7.'
    },
    projectManagement: {
      title: 'Gestion de Projet',
      description: 'Gestion de projet experte garantissant des implémentations IT réussies. Nous livrons des projets dans les délais et le budget, en coordonnant tous les aspects de la planification au déploiement avec des méthodologies éprouvées.'
    },
    cisoService: {
      title: 'CISO-as-a-Service',
      description: 'Accédez à une expertise en sécurité de niveau exécutif sans coûts à temps plein. Notre service CISO virtuel fournit un leadership stratégique en sécurité, des conseils de conformité et une gestion des risques pour votre organisation.'
    }
  },
  industries: {
    title: 'Secteurs que nous Servons',
    subtitle: 'Approuvé par des organisations de tous secteurs dans le monde entier, offrant l\'excellence dans chaque projet.',
    industry: {
      name: 'Industrie',
      description: 'Installations de fabrication et de production'
    },
    retail: {
      name: 'Commerce',
      description: 'Magasins et plateformes e-commerce'
    },
    healthcare: {
      name: 'Santé',
      description: 'Hôpitaux et centres médicaux'
    },
    government: {
      name: 'Gouvernement',
      description: 'Organisations du secteur public'
    }
  },
  about: {
    sectionTitle: 'À PROPOS DE NOUS',
    title: 'Votre Partenaire IT de Confiance depuis le Premier Jour',
    description: 'Basés en Flandre occidentale, Belgique, nous sommes un fournisseur de services IT de premier plan avec une portée mondiale. Notre équipe de professionnels certifiés fournit des solutions innovantes dans tous les secteurs - de la fabrication et du commerce à la santé et aux secteurs gouvernementaux.',
    mission: 'Notre mission est de donner aux entreprises les moyens d\'agir avec une infrastructure IT fiable, sécurisée et évolutive qui stimule la transformation numérique et l\'excellence opérationnelle.',
    gdprCompliant: 'Conforme RGPD',
    support247: 'Support 24/7'
  },
  cta: {
    title: 'Prêt à transformer votre infrastructure IT ? Construisons ensemble quelque chose d\'exceptionnel.',
    button: 'Planifier une Consultation'
  },
  contact: {
    sectionTitle: 'CONTACTEZ-NOUS',
    title: 'Discutons de vos Besoins IT',
    subtitle: 'Remplissez le formulaire ci-dessous et nous vous répondrons dans les 24 heures',
    subtitleShort: 'Remplissez le formulaire ci-dessous et nous vous répondrons dans les 24 heures',
    form: {
      name: 'Nom Complet',
      email: 'Adresse E-mail',
      company: 'Nom de l\'Entreprise',
      phone: 'Numéro de Téléphone',
      message: 'Message',
      verification: 'Vérification : Combien font',
      verificationPlaceholder: 'Entrez la réponse',
      required: '*',
      namePlaceholder: 'Jean Dupont',
      emailPlaceholder: 'jean@entreprise.be',
      companyPlaceholder: 'Votre Entreprise',
      phonePlaceholder: '+32 123 45 67 89',
      messagePlaceholder: 'Parlez-nous de vos besoins IT...',
      charactersCount: 'caractères',
      submit: 'Envoyer le Message',
      sending: 'Envoi en cours...',
      successMessage: 'Merci ! Votre message a été envoyé avec succès. Nous vous répondrons bientôt.',
      errorMessage: 'Veuillez répondre correctement à la question de vérification et réessayer.'
    }
  },
  footer: {
    description: 'Fournisseur de services IT de premier plan offrant des solutions innovantes pour l\'infrastructure, la numérisation, la sauvegarde et la surveillance dans le monde entier.',
    solutions: 'Solutions',
    copyright: '© 2025 IT Services. Tous droits réservés.',
    poweredBy: 'Propulsé par Readdy',
    privacy: 'Politique de Confidentialité',
    terms: 'Conditions d\'Utilisation'
  },
  cookies: {
    title: 'Nous respectons votre vie privée',
    description: 'Nous utilisons des cookies pour améliorer votre expérience de navigation, proposer du contenu personnalisé et analyser notre trafic. En cliquant sur "Tout accepter", vous consentez à notre utilisation des cookies.',
    customize: 'Personnaliser',
    acceptAll: 'Tout accepter',
    rejectAll: 'Tout refuser',
    savePreferences: 'Enregistrer les préférences',
    settingsTitle: 'Préférences des cookies',
    necessary: 'Cookies nécessaires',
    alwaysActive: 'Toujours actif',
    necessaryDesc: 'Ces cookies sont essentiels au bon fonctionnement du site web. Ils permettent des fonctionnalités de base comme la navigation et l\'accès aux zones sécurisées.',
    analytics: 'Cookies analytiques',
    analyticsDesc: 'Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site web en collectant et en rapportant des informations de manière anonyme.',
    marketing: 'Cookies marketing',
    marketingDesc: 'Ces cookies sont utilisés pour suivre les visiteurs sur les sites web afin d\'afficher des publicités et des campagnes marketing pertinentes.'
  }
};
